<template>
  <div class="container">
    <h1 class="title is-size-4-mobile">{{ $t("Locations") }}</h1>

    <div class="columns is-multiline">
      <div
        class="column is-full-mobile is-half-tablet is-one-third-desktop is-one-quarter-widescreen is-one-fifth-fullhd"
      >
        <a
          class="project button is-primary is-fullwidth"
          @click.prevent="openCreation"
        >
          <span class="icon is-large"><i class="fa fa-plus"/></span>
          <span> {{ $t("Create location") }} </span>
        </a>
      </div>
      <div
        class="column is-full-mobile is-half-tablet is-one-third-desktop is-one-quarter-widescreen is-one-fifth-fullhd"
        v-for="(projectName, projectId) in projects"
        :key="projectId"
      >
        <router-link
          :to="`/projects/${projectId}`"
          class="project button is-fullwidth"
        >
          <span class="icon top-right"><i class="fa fa-star"/></span>
          <span>
            <strong>{{ projectName }}</strong>
          </span>
        </router-link>
      </div>
    </div>

    <modal-closable
      :title="$t('Create location')"
      @close="cancelCreation"
      :is-open="creating"
    >
      <input-field
        type="text"
        :label="$t('Location name')"
        :placeholder="$t('My new awesome location')"
        v-model="projectName"
        @focus="projectName_onFocus"
        :errors="projectName_errorsIfTouched"
      />

      <div class="field" v-if="isDemoEnv">
        <label class="label">
          {{ $t("Fill with predefined data? (demo location)") }}
        </label>
        <toggle-button-field
          v-model="useDemoData"
          :positiveLabel="$t('Yes')"
          :negativeLabel="$t('No')"
        />
      </div>

      <div slot="footer">
        <button class="button" @click="cancelCreation">
          {{ $t("Cancel") }}
        </button>
        <button
          class="button is-primary"
          @click="createProject"
          :disabled="!group_valid"
        >
          {{ $t("Create location") }}
        </button>
      </div>
    </modal-closable>
  </div>
</template>

<script>
import { state, actions } from "@/store"
import { InputField, ToggleButtonField } from "@/components/form"
import { ModalClosable } from "@/components/modal"
import { validator, size, required, nonEmpty } from "@/validator"

export default {
  name: "project-manager",
  mixins: [validator],
  components: {
    InputField,
    ToggleButtonField,
    ModalClosable
  },
  data() {
    return {
      creating: false,
      projectName: "",
      useDemoData: this.isDemoEnv
    }
  },
  validations: {
    projectName: [required, size(3, 32), nonEmpty]
  },
  computed: {
    projects() {
      return state.user && state.user.projects
    },
    isDemoEnv() {
      return state.isDemoEnv
    }
  },
  methods: {
    openCreation() {
      this.projectName_touched = false
      this.projectName = ""
      this.creating = true
      actions.clearErrors()
    },
    createProject() {
      this.cancelCreation()
      if (this.useDemoData) {
        actions
          .createDemoProject(this.projectName, "€")
          .catch(actions.addError("create-demo-error"))
      } else {
        actions
          .createProject(this.projectName, "€")
          .catch(actions.addError("create-project-error"))
      }
    },
    cancelCreation() {
      this.creating = false
    }
  }
}
</script>

<style lang="scss" scoped>
.project {
  height: 9em;
  position: relative;
}
.top-right {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
